import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FuseSharedModule } from '@fuse/shared.module';

import { SharedModule } from '../../shared/shared.module';
// import { AvatarModule } from 'ngx-avatar';
import { PermissionType } from 'app/enums/permission.enum';
import { PermissionGuard } from 'app/infrastructure/route-guards/permission-guard.service';
// PIVOT VIEW
import { SelectedTenantComponent } from './selected-tenant.component';
import { LanguageService } from 'app/services/language.service';

const routes: Routes = [
    {
        path: '',
        component: SelectedTenantComponent
    },
];

@NgModule({
    declarations: [
        SelectedTenantComponent,
    ],
    imports: [
        RouterModule.forChild(routes),
        FuseSharedModule,
        SharedModule,
    ],
    providers: [
        LanguageService
    ]
})

export class SelectedTenantModule { }
